import React from "react"
import {TextModel} from "models/Text"
import {FilterIcon, FiltersMenuButton} from "./components"
import env from "../../../../../config/env"

interface StandardFiltersMenuButtonProps {
    text: TextModel
    disableIcon: boolean
    openFiltersPanel: (event: React.MouseEvent<HTMLButtonElement>) => void
}

const FILTER_ICON = "next_filter_mobile_menu.svg"

export const StandardFiltersMenuButton = ({text, disableIcon, openFiltersPanel}: StandardFiltersMenuButtonProps) => {
    return (
        <FiltersMenuButton data-testid="plp-filters-menu-btn" onClick={openFiltersPanel}>
            {!disableIcon && (
                <FilterIcon
                    src={`${env.REACT_APP_BLOB_STORAGE_PATH}/icons/shared/${FILTER_ICON}`}
                    alt={text.assetsAlt.closeIcon}
                    data-testid="plp-filters-menu-icon"
                />
            )}
            <div>{text.labels.filterMenu}</div>
        </FiltersMenuButton>
    )
}

export default StandardFiltersMenuButton
